<template lang="html">
<div>
  <Swipe/>
  
  <div class="item_title">
    <span>&nbsp;</span>
    <h2>玩转社区</h2>
    <a href="javascript:;"  @click="sign_in" ><i>&#xe611;</i>签到</a>
    
  </div>
 
  <ul class="nav_list">
    <router-link tag="li" to="/block" class="border_top"><i>&#xe624;</i><span>论坛版块</span></router-link>
    <router-link tag="li" to="/integral" class="border_top border_right"><i>&#xe6f2;</i><span>积分商城</span></router-link>
    <router-link tag="li" to="/photo" ><i>&#xe609;</i><span>产品图集</span></router-link>
    <router-link tag="li" to="/blocklist/57" class="border_right"><i>&#xe630;</i><span>坚果动态</span></router-link>
    <li  @click="sign_in2"><i>&#xe615;</i><span>游戏互动</span></li>
    <router-link tag="li" to="/blocklist/47" class="border_right"><i>&#xe606;</i><span>坚果活动</span></router-link>
  </ul>

  <div class="tab_container">
    <van-tabs v-model="active" sticky>
      <van-tab title="活动">
        <ul class="tab_left_list">
          <router-link v-if="item.tid != '0'" tag="li" class="tab_left_item" v-for="(item, index) in commendData" :key="index" :to="`/article/${item.tid}`">
            <h2>{{item.title}}</h2>
            <div class="util">
              <span>[{{item.fields.forumname}}] 发表于{{item.startdate}}</span>
              <div class="right_box">
                <b><i>&#xe68a;</i><em>{{item.fields.views}}</em></b>
                <b><i>&#xe621;</i><em>{{item.fields.replies}}</em></b>
              </div>
            </div>
            <img v-lazy="item.thumbpath" alt="">
          </router-link>
          <li v-else="item.tid == '0'" class="tab_left_item">
          <a :href="item.url" target="_blank">
            <h2>{{item.title}}</h2>
            <div class="util">
              <span>[{{item.fields.forumname}}] 发表于{{item.startdate}}</span>
              <div class="right_box">
                <b><i>&#xe68a;</i><em>{{item.fields.views}}</em></b>
                <b><i>&#xe621;</i><em>{{item.fields.replies}}</em></b>
              </div>
            </div>
            <img v-lazy="item.thumbpath" alt="">
          </a>
        </li>
        </ul>
        <span class="loadMore" @click="loadMore">{{loadMoreText}}</span>
      </van-tab>
      <van-tab title="主题">
        <ul class="tab_right_list">
          <router-link tag="li" class="tab_right_item" v-for="(i, index) in forumdisplayData" :key="index" :to="`/article/${i.tid}`">
            <div class="item_left">
              <h2>{{i.subject}}</h2>
              <span>{{i.author}}</span>
              <em>{{i.dateline}}发布</em>
            </div>
            <div class="item_right">
              <img :src="`http://ucenter.jmgo.com/avatar.php?uid=${i.authorid}&size=middle`" alt="">
            </div>
          </router-link>
        </ul>
        <span class="loadMore" @click="forumdisplayLoadMore">{{loadMoreText}}</span>
      </van-tab>
    </van-tabs>
  </div>
  <div class="bottom_null_box"></div>
  <van-popup v-model="show">
      <div class="padding_div">
        <input class="signinput" type="text" name="" value="" v-model="signTxt" placeholder="填写签到心情">
        <van-button type="danger" size="large" @click="toSign">签到</van-button>
      </div>
    </van-popup>
   
</div>
</template>

<script>
import Vue from 'vue'
import utilAxios from '@/utils/axios'
import ItemTitle from '@/components/ItemTitle/ItemTitle'
import { Tab, Tabs } from 'vant'
import Swipe from '@/components/Swipe/Swipe'
import Qs from 'qs'
import { Toast } from 'vant'
import { Popup } from 'vant'
import { Button } from 'vant'
Vue.use(Button)
Vue.use(Popup)
Vue.use(Toast)
Vue.use(Tab).use(Tabs)

export default {
  components: {
    Swipe,
    ItemTitle
  },
  data() {
    return {
      active: 0,
      commendData: [],
      forumdisplayData: [],
      page: 1,
      page1: 1,
      show:false,
      signTxt: '',
      formhash:'',
      isSign:'0',
      uid:'0',
      loadMoreText: '点击加载更多',
      loadMoreText1: '点击加载更多',
      mobile:'',

    }
  },
  beforeCreate() {
    Toast.loading({
      mask: false,
      message: '加载中...'
    })
  },
  created() {
    this.uid = this.getCookie('ECS[user_id]')
    this.mobile=this.getCookie('ECS[mobile]')
    this.getCommendData()
    this.getForumdisplayData()
  },
  methods: {

    trim(str) {
      return str.replace(/^\s\s*/, '').replace(/\s\s*$/, '')
    },
    getCookie(name) {
      let result;
      let cookies = document.cookie.split(';')
      for (let i = 0; i < cookies.length; i++) {
        let cookie = this.trim(cookies[i])
        if (cookie.substring(0, name.length + 1) == (name + '=')) {
          result = decodeURIComponent(cookie.substring(name.length + 1))
        }
      }
      return result
    },
    /*-----获取首页推荐数据-------*/
    getCommendData() {
      utilAxios.get({
        url: '/new_api.php?module=commend&page='+ this.page,
        method: 'GET',
        callback: (res) => {
          if (res.data.code == 100) {
            this.commendData = res.data.data
            this.formhash=res.data.formhash
            this.uid=res.data.uid
            this.isSign=res.data.isSign
          }
          Toast.clear()

        }
      })
    },
    /*-----获取首页推荐分页数据-------*/
    loadMore() {
      this.page = this.page + 1
      utilAxios.get({
        url: '/new_api.php?module=commend&page='+ this.page,
        method: 'GET',
        callback: (res) => {
          if (res.data.code == 100) {
            for(let i in res.data.data){
              this.commendData.push(res.data.data[i])
            }
            console.log(this.commendData)
          }else if(res.data.code == 300){
            this.loadMoreText = res.data.msg
          }
        }
      })
    },
    /*-----获取首页活动数据-------*/
    getForumdisplayData() {
      utilAxios.get({
        url: '/new_api.php?module=forum&mod=forumdisplay&fid=47&page='+ this.page1,
        method: 'GET',
        callback: (res) => {
          if (res.data.code == 100) {
            this.forumdisplayData = res.data.list
            
          }
          Toast.clear()
        }
      })
    },
    /*-----获取首页活动分页数据-------*/
    forumdisplayLoadMore() {
      this.page1 = this.page1 + 1
      utilAxios.get({
        url: '/new_api.php?module=forum&mod=forumdisplay&fid=47&page='+ this.page1,
        method: 'GET',
        callback: (res) => {
          if (res.data.code == 100) {
            for(let i in res.data.list){
              this.forumdisplayData.push(res.data.list[i])
            }
            console.log(this.forumdisplayData)
          }else if(res.data.code == 300){
            this.loadMoreText1 = res.data.msg
          }
        }
      })
    },
    sign_in(){
    console.log(this.isSign=='0')
      if(!this.uid || this.uid=='0'){
         window.location.href="https://www.jmgo.com/mobile/user.php?act=bbslogin&sync=bbs&loginhash=&back_act="+escape('http://bbs.jmgo.com/dist/#/sign')
      }else{
        if(this.isSign=='0'){
          this.show=true
        }else{
          this.show=false
          this.$router.push('/sign')
        }
        

      }
      
      console.log(this.show)
    },
    sign_in2(){
      if(!this.uid || this.uid=='0'){
         window.location.href="https://www.jmgo.com/mobile/user.php?act=bbslogin&sync=bbs&loginhash=&back_act="+escape('http://bbs.jmgo.com/dist/#/sign')
      }else{
        this.$router.push('/sign')

      }
      
      console.log(this.show)
    },
    toSign() {
      const data = Qs.stringify({"formhash": this.formhash,"message": this.signTxt,})
      utilAxios.formpost({
        url: '/new_api.php?module=dsu&operation=qiandao&qdxq=kx&qdmode=1',
        method: 'POST',
        data:data,
        callback: (res) => {
          if (res.data.code == 100) {
               Toast.success(res.data.msg)
                 this.show = false
                 this.$router.push('/sign')
             } else {
               Toast.fail(res.data.msg)
             }
        }
      })
    },
    
    
  }
}
</script>

<style lang="scss">
.item_title{
  height: .3rem;
  padding: .1rem;
  line-height: .3rem;
  background: #fff;
  display: -ms-flexbox;
  display: flex;
}
.item_title span {
    display: inline-block;
    width: .03rem;
    height: 100%;
    background: #ee2a3a;
}
.item_title h2 {
    padding-left: .1rem;
    font-size: .14rem;
    -ms-flex: 1;
    flex: 1;
}
.item_title a {
    width: .6rem;
    height: .3rem;
    background: #ee2a3a;
    border-radius: .04rem;
    text-align: center;
    color: #fff;
}
i {
    font-family: iconfont;
}
.nav_list {
    padding: 0.1rem;
    display: flex;
    flex-wrap: wrap;
    border-top: 1px solid rgba(234,234,234,.3);
    background: #fff;
    li {
        width: 50%;
        height: 0.44rem;
        line-height: 0.44rem;
        box-sizing: border-box;
        border-bottom: 1px solid rgba(234,234,234,.3);
        border-left: 1px solid rgba(234,234,234,.3);
        i {
            font-size: 0.26rem;
            padding: 0 0.15rem;
            vertical-align: bottom;
            color: rgb(83, 169, 254);
            line-height: 0.44rem;
        }
        span {
            font-size: 0.13rem;
            vertical-align: bottom;
        }
    }
    li.border_top {
        border-top: 1px solid rgba(234,234,234,0.3);
    }
    li.border_right {
        border-right: 1px solid rgba(234,234,234,0.3);
    }
}

.tab_container{
  margin-top: .1rem;
  .tab_left_list{
    padding: .1rem;
    background: #fff;
    .tab_left_item{
      margin-bottom: .1rem;
      a{
        color: #222;
      }
      h2{
        font-size: .14rem;
        line-height: .4rem;
      }
      .util{
        display: flex;
        width: 100%;
        height: .3rem;
        line-height: .3rem;
        span{
          flex: 3;
        }
        .right_box{
          flex: 2;
          display: flex;
          justify-content: flex-end;
          b{
            padding: 0 .05rem;
            i{
              padding: 0 .04rem;
            }
          }
        }
      }
    }
    img{
      width: 100%;
      height: 1.25rem;
    }
  }
  .loadMore{
    display: block;
    width: 100%;
    height: .4rem;
    text-align: center;
    line-height: .4rem;
  }
  .tab_right_list{
    padding: .1rem;
    background: #fff;
    .tab_right_item{
      display: flex;
      padding: .1rem 0;
      border-bottom: 1px solid #eaeaea;
      .item_left{
        flex: 1;
        h2{
          font-size: .14rem;
          color: #222;
          line-height: .2rem;
        }
        span{
          font-size: .12rem;
          color: #666;
          line-height: .3rem;
          margin-right: .1rem;
        }
        em{
          font-size: .12rem;
          color: #888;
          line-height: .3rem;
        }
      }
      .item_right{
        width: .6rem;
        height: .6rem;
        img{
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
.van-popup{
  display:block;
}

.padding_div{
   
    padding: .2rem;
    .signinput{
      margin: .1rem 0;
      height: .3rem;
      border: none;
      border:1px solid #eee;
      width: 2rem;
    }
    .van-button--large {
      width: 100%;
      height: 40px;
      line-height: 38px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Home/Home.vue